import { AccommodationRoomTypeAttributes, AccommodationRoomTypeTypes } from '@/types'
import { CreateAccommodationRoomTypeMutation } from './__generated__/create_mutation'
import { Mutation as CreateMutation } from './create_mutation'
import { useForm } from '@/helpers/useForm'
import { useEffect } from 'react'
import { Query as TableQuery } from './table_query'

interface Props {
  accommodationId: string
  onSuccess: () => void
}

export const Form = ({ accommodationId, onSuccess }: Props) => {
  const {
    save,
    saveSuccess,
    formBuilder,
    mutationLoading
  } = useForm<CreateAccommodationRoomTypeMutation, AccommodationRoomTypeAttributes, never, never>({
    defaultValues: {
      accommodationId,
      name: '',
      capacity: 1,
      notes: '',
      layout: AccommodationRoomTypeTypes.Single
    },
    mutation: CreateMutation,
    resultKey: 'createAccommodationRoomType',
    refetchQueries: [TableQuery]
  })

  useEffect(() => { if (saveSuccess) onSuccess() }, [saveSuccess, onSuccess])

  return (
    <div className="flex flex-col gap-6">
      { formBuilder.buildQueryError() }
      { formBuilder.buildField({ name: 'Name', field: 'name', type: 'text' }) }
      <div className="grid grid-cols-2 gap-6">
        { formBuilder.buildField({ name: 'Capacity', field: 'capacity', type: 'integer' }) }
        { formBuilder.buildField({ name: 'Layout', field: 'layout', type: 'room-type' }) }
      </div>
      { formBuilder.buildField({ name: 'Notes', field: 'notes', type: 'textarea' }) }
      { formBuilder.saveButton(save, mutationLoading, saveSuccess) }
    </div>
  )
}
